import React from 'react';
import {
  useLoungeAirportIata,
  useLoungeTerminal,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';

const LoungeAirportandTerminal = () => {
  const { loungeId } = useRouteParams();
  const terminal = useLoungeTerminal(loungeId);
  const loungeAirport = useLoungeAirportIata(loungeId);

  return (
    <div className="margin-2-b tw-text-xl">
      <span className="tw-capitalize tw-text-gray-800">{loungeAirport}</span> •{' '}
      {terminal}
    </div>
  );
};

export default LoungeAirportandTerminal;
